import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IconSpriteModule } from '@personal-area/icon-sprite';

export enum NotificationType {
  Accent = 'accent',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
@Component({
  selector: 'pac-notification',
  styleUrls: ['./notification.component.scss'],
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconSpriteModule,
  ]
})
export class NotificationComponent implements OnChanges {
  @Input() type: NotificationType = NotificationType.Info;
  @Input() text = '';
  @Input() url = '';
  @Input() urlText = '';

  public notificationType = NotificationType.Info;
  public spriteItem = 'notification-info';

  private _notificationTypes = new Map([
    [ NotificationType.Info, 'notification-info' ],
    [ NotificationType.Accent, 'notification-info' ],
    [ NotificationType.Warning, 'notification-warning' ],
    [ NotificationType.Error, 'notification-error' ],
    [ NotificationType.Success, 'notification-success' ],
  ]);

  public ngOnChanges(): void {
    this.notificationType = this._notificationTypes.has(this.type) ? this.type : NotificationType.Info;
    this.spriteItem = this._notificationTypes.get(this.notificationType) || 'notification-info';
  }
}
